import React, { type ReactElement } from 'react';

import classNames from 'classnames';
import numeral from 'numeral';

import Discount from '@/common/components/discount/discount.component';
import { appConfigs } from '@/common/configs/app.config';

export interface PriceProps {
  className?: string;
  price: number;
  discount?: number;
  priceClassName?: string;
  priceWrapperClassName?: string;
  discountClassName?: string;
  totalPrice?: number;
  alignment?: 'vertical' | 'horizontal';
  currencyClassName?: string;
}

export default function Price({
  className,
  priceWrapperClassName,
  priceClassName,
  discountClassName,
  price,
  discount,
  alignment = 'vertical',
  currencyClassName,
}: PriceProps): ReactElement {
  const numericString = price?.toString().replace(/,/g, '');
  const productTotalPrice = discount
    ? parseInt(numericString) * ((100 - discount) / 100)
    : parseInt(numericString);

  const verticalPrice = (
    <div
      className={classNames(' flex h-full flex-col lg:pt-0', priceClassName)}
    >
      <div className="text-left text-xs lg:text-sm lg:font-semibold">
        {numeral(productTotalPrice).format('0,0')}
      </div>

      <div
        className={classNames(
          'right-0 flex justify-end gap-1 text-left text-xs text-secondary-300 lg:text-sm  lg:font-medium ',
          discountClassName
        )}
      >
        {discount && discount !== 0 ? (
          <Discount price={price} className={discountClassName} />
        ) : (
          ''
        )}
        <span className={classNames(currencyClassName)}>
          {appConfigs.currency}
        </span>
      </div>
    </div>
  );
  const horizontalPrice = (
    <div
      className={classNames('flex items-center justify-end gap-x-1', className)}
    >
      {discount !== (0 || undefined) && (
        <Discount price={price} className={discountClassName} />
      )}
      <div
        className={classNames(
          'flex items-center justify-center gap-x-0.5',
          priceWrapperClassName
        )}
      >
        {/* numeric price kept in a <p> for semantic/SEO reasons */}
        <p className={classNames('text-left text-sm ', priceClassName)}>
          {numeral(productTotalPrice).format('0,0')}
        </p>

        <span className={discountClassName}>{appConfigs.currency}</span>
      </div>
    </div>
  );

  const pricingType = {
    vertical: verticalPrice,
    horizontal: horizontalPrice,
  };

  return <> {pricingType[alignment]} </>;
}
